import React from 'react';
import { createUseStyles, useTheme } from 'react-jss';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var basePath = process.env.NODE_ENV !== 'production' ? 'cdn.mtassets.net' : 'cdn.smassets.net';
var font = {
  // todo: created ticket to update path once fonts live in CDN for good. https://jira.surveymonkey.com/browse/WRENCH-1128
  assets: {
    base: "https://".concat(basePath, "/assets/wds-core_4_20_1"),
    path: '/fonts/National2Web',
    name: "'National 2'",
    versions: 2
  },
  fontFamily: {
    base: "'National 2', 'Helvetica Neue', Helvetica, Arial, 'Hiragino Sans', 'Hiragino Kaku Gothic Pro', '游ゴシック', '游ゴシック体', YuGothic, 'Yu Gothic', 'ＭＳ ゴシック', 'MS Gothic', sans-serif",
    icon: 'Mateo'
  }
};
var fontSize = {
  bodySm: 13,
  body: 15,
  cardTitle: 16,
  sectionTitle: 26,
  pageTitle: 34,
  hero1: 50,
  hero2: 40
};
var fontWeight = {
  light: 300,
  regular: 400,
  medium: 500
};
var palette = {
  transparent: 'transparent',
  primary: {
    main: '#00BF6F',
    contrast: '#FFFFFF'
  },
  secondary: {
    main: '#6B787F',
    contrast: '#FFFFFF'
  },
  success: {
    main: '#00BF6F',
    contrast: '#FFFFFF'
  },
  warning: {
    main: '#F05B24',
    contrast: '#FFFFFF'
  },
  info: {
    main: '#2DCCD3',
    contrast: '#333E48'
  },
  upgrade: {
    main: '#F9BE00',
    contrast: '#333E48'
  },
  muted: {
    main: '#D0D2D3',
    contrast: '#333E48'
  },
  link: {
    main: '#007FAA',
    contrast: '#FFFFFF'
  },

  /**
   * type => text
   */
  text: {
    dark: '#333E48',
    light: '#FFFFFF',
    darkMuted: '#6B787F',
    lightMuted: '#D0D2D3',
    link: '#007FAA'
  },
  background: {
    main: '#F7F8FA',
    light: '#FFFFFF',
    dark: '#333E48',
    overlay: 'rgba(107, 120, 127, .86)',
    accent: '#EDEEEE'
  },
  border: {
    main: '#D0D2D3',
    active: '#00BF6F',
    hover: '#9DA5AA',
    muted: '#EDEEEE'
  },
  data: {
    one: '#507CB6',
    two: '#00BF6F',
    three: '#6BC8CD',
    four: '#F9BE00',
    five: '#7D5E90',
    six: '#DB4D5C',
    seven: '#768086',
    eight: '#D25F90',
    nine: '#A38364',
    ten: '#FF8B4F'
  }
};
var spacing = {
  1: 4,
  2: 8,
  3: 12,
  4: 16,
  5: 24,
  6: 32,
  7: 64,
  8: 96,
  9: 128
};
var motion = {
  curve: {
    enter: 'cubic-bezier(0, 0, 0, 1)',
    exit: 'cubic-bezier(1, 0, 1, 1)',
    ease: 'cubic-bezier(.2, 0, .1, 1)',
    easeReverse: 'cubic-bezier(.9, 0, .8, 1)',
    bounceStart: 'cubic-bezier(0, 0, .1, 1)',
    bounceEnd: 'cubic-bezier(.2, 0, 0, 1)'
  },
  fade: {
    speed: {
      slow: 300,
      normal: 200,
      fast: 100
    }
  },
  slide: {
    speed: {
      slow: 450,
      normal: 350,
      fast: 250
    },
    distance: {
      normal: 25,
      near: 5,
      far: 75
    }
  }
};
var border = {
  main: [1, 'solid', palette.border.main],
  hover: [1, 'solid', palette.border.hover],
  active: [1, 'solid', palette.border.active],
  muted: [1, 'solid', palette.border.muted],
  dark: [1, 'solid', palette.background.dark],
  light: [2, 'solid', palette.background.light]
};
var radius = {
  zero: 0,
  small: 2,
  medium: 24,
  large: '50%'
};
var shadow = {
  none: 'none',
  sky: '0 2px 4px 0 rgba(0, 0, 0, 0.14)',
  space: '0 2px 8px 0 rgba(0,0,0,0.14)'
};
var breakpoints = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200
};
var iconSize = {
  sm: 13,
  md: 16,
  lg: 26,
  xl: 34
};
var zIndex = {
  none: 0,
  sky: 999,
  space: 9999
};
var theme = {
  type: _objectSpread(_objectSpread({}, font), {}, {
    fontSize: fontSize,
    fontWeight: fontWeight
  }),
  palette: palette,
  spacing: spacing,
  motion: motion,
  border: border,
  radius: radius,
  shadow: shadow,
  breakpoints: breakpoints,
  iconSize: iconSize,
  zIndex: zIndex
};
var useStyles = createUseStyles(function (theme) {
  var _theme$type = theme.type,
      assets = _theme$type.assets,
      fontFamily = _theme$type.fontFamily,
      fontWeight = _theme$type.fontWeight,
      fontSize = _theme$type.fontSize;
  var fontPath = "".concat(assets.base).concat(assets.path);
  var fontFaces = Object.keys(fontWeight).map(function (name) {
    // we need this because the font file names are all National2-<Weight>.2.ext
    var upperCaseName = "".concat(name[0].toUpperCase()).concat(name.substring(1));
    var weight = fontWeight[name];
    return {
      fontFamily: assets.name,
      fontWeight: weight,
      fontDisplay: 'swap',
      src: "url(".concat(fontPath, "-").concat(upperCaseName, ".").concat(assets.version, ".woff2) format('woff2')"),
      fallbacks: [{
        src: "url(".concat(fontPath, "-").concat(upperCaseName, ".").concat(assets.version, ".woff) format('woff')")
      }, {
        src: "url(".concat(fontPath, "-").concat(upperCaseName, ".").concat(assets.version, ".eot#iefix) format('embedded-opentype')")
      }]
    };
  });
  return {
    '@font-face': fontFaces,
    '@global': {
      "[class*='wrench'], [class*='wrench']::before, [class*='wrench']::after": {
        fontFamily: fontFamily.base,
        '-webkit-font-smoothing': 'antialiased',
        fontSize: fontSize.body,
        boxSizing: 'border-box',
        padding: 0,
        margin: 0,
        listStyle: 'none'
      }
    }
  };
});

var GlobalStyles = function GlobalStyles() {
  var theme = useTheme();
  useStyles({
    theme: theme
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null);
};

GlobalStyles.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "GlobalStyles"
};
export { GlobalStyles, theme as WrenchTheme };